import { createSelector } from 'reselect'

export const openAlertsSelector = (state) => state.openAlerts

export const openAlertsCounts$ = createSelector(
  openAlertsSelector,
  ({ counts = {} }) => counts
)
